/**
 * Botón de acción unificado: icono arriba, texto abajo, mismo estilo que Información del servicio.
 */

import React from 'react';
import {View, Text, StyleSheet, TouchableOpacity, ViewStyle} from 'react-native';
import {useTheme} from 'react-native-paper';
import Icon from 'react-native-vector-icons/MaterialIcons';
import {ActivityIndicator} from 'react-native-paper';

export type ActionButtonVariant = 'outlined' | 'contained';

interface ActionButtonProps {
  icon: string;
  label: string;
  variant?: ActionButtonVariant;
  onPress: () => void;
  disabled?: boolean;
  loading?: boolean;
  flex?: number;
  danger?: boolean;
  style?: ViewStyle;
}

export const ActionButton: React.FC<ActionButtonProps> = ({
  icon,
  label,
  variant = 'contained',
  onPress,
  disabled = false,
  loading = false,
  flex = 1,
  danger = false,
  style,
}) => {
  const theme = useTheme();
  const isOutlined = variant === 'outlined';
  const isDanger = danger || (isOutlined && icon === 'close-circle');

  const backgroundColor = isOutlined ? 'transparent' : theme.colors.primary;
  const borderWidth = isOutlined ? 2 : 0;
  const borderColor = isDanger ? theme.colors.error : theme.colors.outline;
  const iconColor = isOutlined
    ? isDanger
      ? theme.colors.error
      : theme.colors.primary
    : '#fff';
  const labelColor = isOutlined
    ? isDanger
      ? theme.colors.error
      : theme.colors.primary
    : '#fff';

  return (
    <TouchableOpacity
      onPress={onPress}
      disabled={disabled}
      activeOpacity={0.7}
      style={[
        styles.button,
        {
          flex,
          backgroundColor,
          borderWidth,
          borderColor,
        },
        style,
      ]}>
      <View style={styles.content}>
        {loading ? (
          <ActivityIndicator size="small" color={labelColor} style={styles.icon} />
        ) : (
          <Icon name={icon as any} size={36} color={iconColor} style={styles.icon} />
        )}
        <Text style={[styles.label, {color: labelColor}]}>{label}</Text>
      </View>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  button: {
    minHeight: 88,
    borderRadius: 12,
    justifyContent: 'center',
    alignItems: 'center',
  },
  content: {
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  icon: {
    marginBottom: 6,
  },
  label: {
    fontSize: 19,
    fontWeight: '600',
  },
});

/** Estilos para la barra de acciones (contenedor de botones) */
export const actionBarStyles = {
  container: {
    position: 'absolute' as const,
    bottom: 0,
    left: 0,
    right: 0,
    flexDirection: 'row' as const,
    gap: 12,
    paddingHorizontal: 16,
    paddingTop: 20,
    paddingBottom: 32,
    borderTopWidth: 1,
    borderTopColor: '#e5e7eb',
    shadowColor: '#000',
    shadowOffset: {width: 0, height: -2},
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 5,
  },
};
